<template>
  <div>
    <h2>Информация по работе с данным сервисом</h2>

    <c-box>
      <div
        id="accordion"
        class="box-group"
      >
        <accordion-item
          :index="1"
          title="Где можно просмотреть динамику позиций за текущий месяц?"
        >
          <p>Просмотр динамики позиций за текущий месяц доступен на главной странице сервиса, под заголовком "Продвижение сайтов".</p>
          <!-- TODO: добавить скриншот -->
          <p>
            А также через пункт главного меню <router-link
              :to="{ name: 'Positions' }"
              v-text="'Позиции сайта'"
            />.
          </p>
        </accordion-item>

        <accordion-item
          :index="2"
          title="Как выбрать проект для просмотра динамики позиций за текущий месяц?"
        >
          <p>По умолчанию показана динамика для основного проекта.</p>
          <p>Для того, чтобы просмотреть динамику другого проекта, необходимо выбрать другой регион (если необходимо) и выбрать соответствующее ядро.</p>
        </accordion-item>

        <accordion-item
          :index="3"
          title="Где можно посмотреть позиции за выбранный период?"
        >
          <p>
            Для просмотра позиций за выбранный период, необходимо выбрать пункт меню <router-link
              :to="{ name: 'Positions' }"
              v-text="'Позиции сайта'"
            />.
          </p>
          <!-- TODO: добавить скриншот -->
          <p>После этого откроется страница с позициями по Яндексу за последний месяц (либо если проект моложе месяца, то с момента его старта).</p>
          <p>Чтобы выбрать другой период или поисковую систему необходимо воспользоваться фильтрами над таблицей</p>
        </accordion-item>

        <accordion-item
          :index="4"
          title="Как сохранить отчет с позициями за выбранный период?"
        >
          <p>При необходимости сохранения отчета с позициями на компьютере пользователя, необходимо нажать на кнопку "Скачать".</p>
        </accordion-item>

        <accordion-item
          :index="5"
          title="Где можно просмотреть детализацию по стоимости продвижения?"
        >
          <p>
            Для просмотра стоимости продвижения запросов необходимо, находясь на странице <router-link
              :to="{ name: 'Positions' }"
              v-text="'Текущие позиции'"
            />, нажать на ссылку "Отчет по деньгам".
          </p>
        </accordion-item>

        <accordion-item
          :index="6"
          title="Как сохранить детализацию по стоимости продвижения?"
        >
          <p>
            При необходимости сохранения детализации по стоимости продвижения на компьютере пользователя, находясь на странице <router-link
              :to="{ name: 'Positions' }"
              v-text="'Текущие позиции'"
            /> нажать на ссылку "Отчет по деньгам" и затем нажать на кнопку "Скачать".
          </p>
        </accordion-item>

        <!-- TODO: функционал еще не реализован -->
        <!--<accordion-item
          :index="7"
          title="Как просмотреть информацию по остановленным проектам?"
        >
          <p>Для просмотра информации по остановленным проектам, необходимо перейти во вкладку “Остановленные” над таблицей со списком проектов на главной странице.</p>
        </accordion-item>-->

        <!-- TODO: функционал еще не реализован -->
        <!--<accordion-item
          :index="8"
          title="Как просмотреть информацию по остановленным проектам?"
        >
          <p>Для просмотра ежемесячных отчетов, необходимо выбрать пункт меню "Отчеты", на открывшейся странице в выпадающем меню выбрать домен и нажать на кнопку "Скачать" напротив интересующего отчета.</p>
          TODO: добавить скриншот
        </accordion-item>-->

        <accordion-item
          :index="9"
          title="Где можно посмотреть информацию из сервисов статистики (Яндекс Метрика, Google Analytics, LiveInternet)?"
        >
          <p>
            Для просмотра информации из сервисов статистики, необходимо выбрать пункт меню <router-link
              :to="{ name: 'Indicators' }"
              v-text="'Показатели сайта'"
            />.
          </p>
          <p>На странице представлены значения показателей сайта, графики и таблицы по видимости, посещаемости, источникам трафика и географии по России. По умолчанию открываются данные по Яндекс Метрике, для просмотра информации из другого сервиса, необходимо нажать на соответствующую кнопку.</p>
          <!-- TODO: добавить скриншот -->
        </accordion-item>

        <accordion-item
          :index="10"
          title="Где можно посмотреть информацию по видимости за определенный месяц?"
        >
          <p>
            Для просмотра информации по видимости за определенный месяц, необходимо выбрать пункт меню <router-link
              :to="{ name: 'Indicators' }"
              v-text="'Показатели сайта'"
            />.
          </p>
          <p>На странице представлены значения показателей сайта, графики и таблицы по видимости, посещаемости, источникам трафика и географии по России. По умолчанию открываются данные по Яндекс Метрике, для просмотра информации из другого сервиса, необходимо нажать на соответствующую кнопку.</p>
          <!-- TODO: добавить скриншот -->
        </accordion-item>

        <accordion-item
          :index="11"
          title="Как часто обновляется информация из сервисов статистики?"
        >
          <p>Информация по сервисам статистики собирается в первых числах текущего месяца за весь предыдущий месяц, т.е. в мае можно посмотреть информацию только за апрель и ранее.</p>
        </accordion-item>

        <accordion-item
          :index="12"
          title="Где можно посмотреть информацию по видимости за определенный месяц?"
        >
          <p>
            Для просмотра информации по видимости за определенный месяц, необходимо выбрать пункт меню <router-link
              :to="{ name: 'Indicators' }"
              v-text="'Показатели сайта'"
            />.
          </p>
          <p>На странице представлены значения показателей сайта, графики и таблицы по видимости, посещаемости, источникам трафика и географии по России. По умолчанию открываются данные по Яндекс Метрике, для просмотра информации из другого сервиса, необходимо нажать на соответствующую кнопку.</p>
          <!-- TODO: добавить скриншот -->
        </accordion-item>

        <accordion-item
          :index="13"
          title="Как часто обновляется информация по видимости?"
        >
          <p>Информация по видимости собирается раз в неделю.</p>
        </accordion-item>

        <accordion-item
          :index="14"
          title="Что такое обратный звонок?"
        >
          <p>Если у Вас по какой-либо причине не получается дозвониться по телефону до своего менеджера, либо у Вас нет времени, то Вы можете воспользоваться услугой "Обратный звонок". Вам нужно только заполнить форму обращения, и менеджер перезвонит по указанному телефону.</p>
        </accordion-item>
      </div>
    </c-box>
  </div>
</template>

<script>
import CBox from '../../components/ui/CBox'
import AccordionItem from '../../components/views/faq/AccordionItem'

export default {
  name: 'HowToWork',
  components: { CBox, AccordionItem }
}
</script>
